import moment from "moment";
import { REQUEST_CHAT_DETAILS, SHOW_CHAT_PROMPT, SHOW_CHAT_PANEL, HIDE_CHAT_PANEL, INIT_EXTERNAL_LISTENER, RECEIVE_EVENT, CLOSE_CHAT, RECEIVE_MYDPD_CHAT_DETAILS, RECEIVE_AVERAGE_WAIT_TIME, GET_CHAT_CONFIG } from "./Constants";
import { receiveQueueMessages, receiveQueuePositionMessages } from "./ChatActions";
export function initExternalListener() {
  return async (dispatch, getState) => {
    const obj = document.getElementById("chat-view-wrapper");
    const chatState = getState().chat;
    obj.addEventListener("dpd/cbot/fmp-submit", function (e) {
      if (!chatState.chatBot.actionPending) {
        return false;
      }
      dispatch({
        type: RECEIVE_EVENT,
        action: "success"
      });
      dispatch(showChatPanel("inflight-success"));
    });
    obj.addEventListener("dpd/cbot/fmp-cancel", function (e) {
      if (!chatState.chatBot.actionPending) {
        return false;
      }
      dispatch({
        type: RECEIVE_EVENT,
        action: "cancel"
      });
      dispatch(showChatPanel());
    });
    return {
      type: INIT_EXTERNAL_LISTENER
    };
  };
}
function requestChatDetails() {
  return {
    type: REQUEST_CHAT_DETAILS
  };
}
function receiveMydpdChatDetails(details) {
  return {
    type: RECEIVE_MYDPD_CHAT_DETAILS,
    details
  };
}
function fetchChatDetails(apiClient) {
  return async (dispatch, getState) => {
    dispatch(requestChatDetails());
    const chatState = getState().chat;
    const parcelCode = chatState.chatBot.parcelCode || window.location.pathname.split("/")[2];
    if (parcelCode) {
      let config = {};
      config = await apiClient.get(GET_CHAT_CONFIG + "?parcelCode=" + parcelCode);
      config.delay = config.loadTime;
      config.available = config.botAvailable;
      config.filtered = false;
      config.businessUnit = chatState.config.businessUnit;
      if (config.serviceWindow) {
        const startWindow = moment(config.serviceWindow.split("-")[0].trim(), "HH:mm");
        const endWindow = moment(config.serviceWindow.split("-")[1].trim(), "HH:mm");
        config.outOfHours = moment().isBefore(startWindow) || moment().isAfter(endWindow);
      }
      dispatch({
        type: RECEIVE_AVERAGE_WAIT_TIME,
        waitTime: config.averageWaitTime
      });
      dispatch(receiveMydpdChatDetails({
        ...config,
        parcelCode
      }));
      dispatch(receiveQueueMessages(config.educationalMessages));
      dispatch(receiveQueuePositionMessages(config.queueMessages));
      return config;
    }
  };
}
export function fetchInitialConfig(apiClient, getParcel) {
  return async dispatch => {
    let config = null;
    try {
      config = await dispatch(fetchChatDetails(apiClient));
    } catch (e) {
      // Too many sentry logs
      if (e.response?.status === 401) {
        dispatch(closeChat());
        return;
      }
      throw new Error(e);
    }
    if (config && config.available === "Y") {
      let delay = config.delay;
      if (config.showDirectly) {
        delay = 0;
      }
      setTimeout(() => {
        dispatch(showChatPrompt());
      }, delay * 1000);
    }
  };
}
export function showChatPrompt() {
  return {
    type: SHOW_CHAT_PROMPT
  };
}
export function showChatPanel(flag) {
  return {
    type: SHOW_CHAT_PANEL,
    flag
  };
}
export function hideChatPanel() {
  return {
    type: HIDE_CHAT_PANEL
  };
}
export function closeChat() {
  return {
    type: CLOSE_CHAT
  };
}